<template>
  <div class="sq-logo">
    <p>powered by 松鼠Ai</p>
    <img src="../../../assets/images/logo_blue.png" alt="">
  </div>
</template>

<script>
export default {
  name: 'SqLogo',
};
</script>

<style lang="scss" scoped>
.sq-logo {
  color: #0491FF;
  font-size: 18px;
  text-align: center;
  font-weight: bold;
  img {
    width: 88px;
  }
}
</style>
